{
  "fr": {
    "aiPrivacyNotice": {
      "backToChat": "Retour au chat IA",
      "pupil": {
        "facts": {
          "aiDoesNotKnowYou": "L'IA ne vous connaît pas tant que vous ne partagez pas de données personnelles.",
          "teacherCanSee": "Votre enseignant·e peut voir ce que vous faites et qui vous êtes."
        },
        "policyLink": "En savoir plus sur la protection des données",
        "rules": {
          "doubtAnswers": "Je ne crois pas tout ce que dit l'IA.",
          "heading": "Deux règles lorsque vous utilisez l'IA :",
          "noPrivateData": "Je ne donne pas mon vrai nom ni d'autres informations privées à l'IA."
        },
        "title": "Protégez vos données"
      },
      "teacher": {
        "handling": {
          "detail": "Les fournisseurs suppriment les demandes au plus tard après 30 jours.",
          "heading": "Comment vos données sont traitées",
          "text": "Pas d'entraînement de modèles d'IA."
        },
        "intro": "Pour une réponse, fobizz envoie votre saisie au prestataire IA que vous avez choisi.",
        "notTransmitted": {
          "detail": "Le fournisseur ne peut pas vous identifier.",
          "heading": "Ce que nous ne transmettons pas",
          "text": "Nom, e\u2011mail, ID utilisateur, école ou adresse IP."
        },
        "policyLink": "Vers la déclaration de protection des données complète",
        "title": "Utilisation des données par les services IA",
        "transmitted": {
          "detail": "(images, audio, PDF, texte)",
          "heading": "Ce que nous transmettons",
          "text": "Vos textes et fichiers téléchargés"
        }
      }
    }
  }
}
